<div class="row" style="justify-content: center">
  <h1 class="text-center" mat-dialog-title>Número de pedido </h1>
</div>
<div class="containerModal">
  <form [formGroup]="numPedido" mat-dialog-content>
    <div class="row">
      <mat-form-field appearance="outline" class="col-lg-12 col-md-12 col-sm-12">
        <mat-label>Número de pedido</mat-label>
        <input matInput matNativeControl type="text"
               formControlName="num">

      </mat-form-field>
    </div>
  </form>
  <div mat-dialog-actions>
    <div class="col-6">
      <button mat-button class="btn-block btn-secondary" (click)="onNoClick()">Cancelar</button>
    </div>
    <div class="col-6">
      <button mat-button class="btn-block btn-primary" (click)="Guardar()">Agregar</button>
    </div>
  </div>
</div>

